import type { TeamUsageDto } from '../../../../../../trustpulse-api/src/application/dto/organization/organization-usage-stats.dto';

/**
 * Sort direction
 */
export type SortDirection = 'asc' | 'desc';

/**
 * Static utility class for sorting team usage data
 */
export class TeamUsageSorter {
  /**
   * Sorts teams by total surveys sent
   * @param teams Array of team usage data
   * @param direction Sort direction (default: descending - most surveys first)
   * @returns Sorted array (creates a new array, does not mutate)
   */
  static sortByTotalSurveys(
    teams: TeamUsageDto[],
    direction: SortDirection = 'desc'
  ): TeamUsageDto[] {
    const sorted = [...teams].sort((a, b) => {
      return direction === 'desc'
        ? b.totalSurveysSent - a.totalSurveysSent
        : a.totalSurveysSent - b.totalSurveysSent;
    });
    return sorted;
  }

  /**
   * Sorts teams by response rate
   * @param teams Array of team usage data
   * @param direction Sort direction (default: descending - highest rate first)
   * @returns Sorted array (creates a new array, does not mutate)
   */
  static sortByResponseRate(
    teams: TeamUsageDto[],
    direction: SortDirection = 'desc'
  ): TeamUsageDto[] {
    const sorted = [...teams].sort((a, b) => {
      return direction === 'desc'
        ? b.averageResponseRate - a.averageResponseRate
        : a.averageResponseRate - b.averageResponseRate;
    });
    return sorted;
  }

  /**
   * Sorts teams by team size
   * @param teams Array of team usage data
   * @param direction Sort direction (default: descending - largest first)
   * @returns Sorted array (creates a new array, does not mutate)
   */
  static sortByTeamSize(
    teams: TeamUsageDto[],
    direction: SortDirection = 'desc'
  ): TeamUsageDto[] {
    const sorted = [...teams].sort((a, b) => {
      return direction === 'desc' ? b.teamSize - a.teamSize : a.teamSize - b.teamSize;
    });
    return sorted;
  }
}
